<div appDialogSelectable appDialogKeyboardEnabled>
  <div
    class="atlas-fraud-detection-rules-dialog"
    (cdkDragStarted)="dialogBoundryService.handleDragStart($event)"
    (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)"
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDrag
  >
    <div appDialogDragArea cdkDragHandle></div>
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-title">Fraud Detection Specifications</div>
        <div class="modal-buttons">
          <div (click)="close()">
            <img src="/assets/icons/Close White.svg" alt="Close" />
          </div>
        </div>
      </div>

      <div class="modal-content-body fraud-detection-rules-body">
        <div class="fraud-detection-rules-shell">
          <section class="rules-card">
            <div class="rules-tabs" role="tablist" aria-label="Fraud detection rule tables">
              <button
                type="button"
                class="rules-tab"
                [class.rules-tab-active]="activeTab === 'timeDeparture'"
                role="tab"
                [attr.aria-selected]="activeTab === 'timeDeparture'"
                (click)="setActiveTab('timeDeparture')"
              >
                Time departure
              </button>
              <button
                type="button"
                class="rules-tab"
                [class.rules-tab-active]="activeTab === 'timeArrival'"
                role="tab"
                [attr.aria-selected]="activeTab === 'timeArrival'"
                (click)="setActiveTab('timeArrival')"
              >
                Time arrival
              </button>
              <button
                type="button"
                class="rules-tab"
                [class.rules-tab-active]="activeTab === 'reserveScores'"
                role="tab"
                [attr.aria-selected]="activeTab === 'reserveScores'"
                (click)="setActiveTab('reserveScores')"
              >
                Reserve scores
              </button>
              <button
                type="button"
                class="rules-tab"
                [class.rules-tab-active]="activeTab === 'supplierScores'"
                role="tab"
                [attr.aria-selected]="activeTab === 'supplierScores'"
                (click)="setActiveTab('supplierScores')"
              >
                Supplier scores
              </button>
            </div>

            <div *ngIf="activeTab === 'timeDeparture'" class="rules-table-wrap" role="tabpanel">
              <table class="rules-table">
                <thead>
                  <tr>
                    <th>Score</th>
                    <th>Rule</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of timeDepartureRows">
                    <td>{{ row.score }}</td>
                    <td>{{ row.note }}</td>
                  </tr>
                </tbody>
              </table>

              <div *ngIf="isLoadingTimeDepartureRules" class="rules-empty-state">
                Loading time departure rules...
              </div>

              <div *ngIf="!isLoadingTimeDepartureRules && timeDepartureRulesLoadFailed" class="rules-empty-state rules-empty-state-error">
                Time departure rules could not be loaded.
              </div>

              <div *ngIf="!isLoadingTimeDepartureRules && !timeDepartureRulesLoadFailed && !timeDepartureRows.length" class="rules-empty-state">
                No time departure rules have been configured yet.
              </div>
            </div>

            <div *ngIf="activeTab === 'timeArrival'" class="rules-table-wrap" role="tabpanel">
              <table class="rules-table">
                <thead>
                  <tr>
                    <th>Score</th>
                    <th>Rule</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of timeArrivalRows">
                    <td>{{ row.score }}</td>
                    <td>{{ row.note }}</td>
                  </tr>
                </tbody>
              </table>

              <div *ngIf="isLoadingTimeArrivalRules" class="rules-empty-state">
                Loading time arrival rules...
              </div>

              <div *ngIf="!isLoadingTimeArrivalRules && timeArrivalRulesLoadFailed" class="rules-empty-state rules-empty-state-error">
                Time arrival rules could not be loaded.
              </div>

              <div *ngIf="!isLoadingTimeArrivalRules && !timeArrivalRulesLoadFailed && !timeArrivalRows.length" class="rules-empty-state">
                No time arrival rules have been configured yet.
              </div>
            </div>

            <div *ngIf="activeTab === 'reserveScores'" class="rules-table-wrap" role="tabpanel">
              <table class="rules-table">
                <thead>
                  <tr>
                    <th>Score</th>
                    <th>Rule</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of reserveScoreRows">
                    <td>{{ row.score }}</td>
                    <td>{{ row.note }}</td>
                  </tr>
                </tbody>
              </table>

              <div *ngIf="isLoadingReserveScoreRules" class="rules-empty-state">
                Loading reserve score rules...
              </div>

              <div *ngIf="!isLoadingReserveScoreRules && reserveScoreRulesLoadFailed" class="rules-empty-state rules-empty-state-error">
                Reserve score rules could not be loaded.
              </div>

              <div *ngIf="!isLoadingReserveScoreRules && !reserveScoreRulesLoadFailed && !reserveScoreRows.length" class="rules-empty-state">
                No reserve score rules have been configured yet.
              </div>
            </div>

            <div *ngIf="activeTab === 'supplierScores'" class="rules-table-wrap" role="tabpanel">
              <table class="rules-table">
                <thead>
                  <tr>
                    <th>Recommendation</th>
                    <th>Score</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of supplierScoreRows">
                    <td>
                      <span class="supplier-score-recommendation">
                        {{ row.recommendation }}
                        <span *ngIf="row.flagged" class="supplier-score-flag" aria-label="Flagged"></span>
                      </span>
                    </td>
                    <td>{{ row.score }}</td>
                  </tr>
                </tbody>
              </table>

              <div *ngIf="isLoadingSupplierScoreRules" class="rules-empty-state">
                Loading supplier score rules...
              </div>

              <div *ngIf="!isLoadingSupplierScoreRules && supplierScoreRulesLoadFailed" class="rules-empty-state rules-empty-state-error">
                Supplier score rules could not be loaded.
              </div>

              <div *ngIf="!isLoadingSupplierScoreRules && !supplierScoreRulesLoadFailed && !supplierScoreRows.length" class="rules-empty-state">
                No supplier score rules have been configured yet.
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>
